import { Question } from "survey-core";
import questionTypes from "view/pages/Forms/EditFormDetails/Components/SurveyJs/questionTypes";

export default class QuestionPhoneNumberModel extends Question {
  getType() {
    return questionTypes.phoneNumber;
  }
}
